import { getInputValue, getMultiSelectValues } from '../../shared/dom.util';
import {
    DWT_PAYLOADS_END_DATE_ELEMENT_ID,
    DWT_PAYLOADS_FACILITY_CODE_ELEMENT_ID,
    DWT_PAYLOADS_RECORD_COUNT_ELEMENT_ID,
    DWT_PAYLOADS_START_DATE_ELEMENT_ID,
    DWT_PAYLOADS_STATUS_ELEMENT_ID,
    dwtPayloadStatusCodesFromMultiselectValues,
    resolveDwtPayloadsRecordCount,
} from '../dwt-payloads.constants';
import type { DwtPayloadsTaskPaneFilter } from '../models/dwt-payloads.model';

/**
 * Reads DWT - Payloads to Trace filter fields from the task pane DOM.
 */
export function readDwtPayloadsTaskPaneFilterFromDom(): DwtPayloadsTaskPaneFilter {
    const recordCountRaw = getInputValue(DWT_PAYLOADS_RECORD_COUNT_ELEMENT_ID);
    const parsedRecordCount = Number.parseInt(recordCountRaw, 10);
    const startDate = getInputValue(DWT_PAYLOADS_START_DATE_ELEMENT_ID);
    const endDate = getInputValue(DWT_PAYLOADS_END_DATE_ELEMENT_ID);

    return {
        recordCount: resolveDwtPayloadsRecordCount(
            Number.isNaN(parsedRecordCount) ? undefined : parsedRecordCount
        ),
        facilityCode: getMultiSelectValues(DWT_PAYLOADS_FACILITY_CODE_ELEMENT_ID),
        status: dwtPayloadStatusCodesFromMultiselectValues(
            getMultiSelectValues(DWT_PAYLOADS_STATUS_ELEMENT_ID)
        ),
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
    };
}
